import React from 'react'
import { StaticImage } from "gatsby-plugin-image"//ローカルから画像を持ってくる
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import styled from 'styled-components'
import * as styles from "./RecruitHeroImage.module.scss";
import {RecruitThemeContent} from "./index"

const RecruitHeroImage = () => {
  const breakpoints = useBreakpoint();
  return(
    <div className={styles.RecruitHeroImage}>
      {
        breakpoints.sm ?
          <StaticImage
            layout="fullWidth"
            src="../../images/recruit/top/heroimage-sp@2x.png"
            alt="heroimage"
          />
          :
          <StaticImage
            layout="fullWidth"
            src="../../images/recruit/top/heroimage@2x.png"
            alt="heroimage"
          />
      }
      <div className={styles.RecruitHeroImage__title}>
        <Div>
          <RecruitThemeContent/>
        </Div>
      </div>
    </div>
  )
}
export default RecruitHeroImage

const Div = styled.div`
  overflow: hidden;
  width: 100%;
`
